import type { IconSvgProps } from '../Icon.types';

export const HouseSimple = ({ fill, width, height, className }: IconSvgProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      
    >
      <path
        d="M17.1336 8.49048L10.8836 2.24058C10.6492 2.00634 10.3314 1.87476 10 1.87476C9.66863 1.87476 9.35081 2.00634 9.11641 2.24058L2.86641 8.49048C2.74978 8.60625 2.65732 8.74405 2.59442 8.89587C2.53151 9.04769 2.49942 9.2105 2.50001 9.37484V16.8747C2.50001 17.0405 2.56586 17.1994 2.68307 17.3167C2.80028 17.4339 2.95925 17.4997 3.12501 17.4997H8.12501C8.29077 17.4997 8.44974 17.4339 8.56695 17.3167C8.68416 17.1994 8.75001 17.0405 8.75001 16.8747V12.4998H11.25V16.8747C11.25 17.0405 11.3159 17.1994 11.4331 17.3167C11.5503 17.4339 11.7092 17.4997 11.875 17.4997H16.875C17.0408 17.4997 17.1997 17.4339 17.317 17.3167C17.4342 17.1994 17.5 17.0405 17.5 16.8747V9.37484C17.5006 9.2105 17.4685 9.04769 17.4056 8.89587C17.3427 8.74405 17.2502 8.60625 17.1336 8.49048ZM16.25 16.2497H12.5V11.8748C12.5 11.709 12.4342 11.5501 12.3169 11.4329C12.1997 11.3157 12.0408 11.2498 11.875 11.2498H8.12501C7.95925 11.2498 7.80028 11.3157 7.68307 11.4329C7.56586 11.5501 7.50001 11.709 7.50001 11.8748V16.2497H3.75001V9.37484L10 3.12494L16.25 9.37484V16.2497Z"
        fill={fill}
      />
    </svg>
  );
};
